import { Grid } from '@material-ui/core';
import React from 'react';

const PlaceholderImage = () => (
  <Grid
    container
    justifyContent="center"
    alignItems="center"
    style={{ border: '1px solid #ccc', borderRadius: 5, minHeight: 300 }}
  >
    <Grid item>Placeholder</Grid>
  </Grid>
);

export default PlaceholderImage;
